import { AidaService } from '@adaptiva/ai/common';
import { Destroyer } from '@adaptiva/core/common';
import { Directive, inject } from '@angular/core';

@Directive()
export abstract class BaseLlmTabComponent extends Destroyer {

	protected readonly aida: AidaService = inject(AidaService);

	protected toggleSearch(): void {
		this.aida.toggleSearch();
	}

}
